export {default} from './weaviate.vue'